import { render, staticRenderFns } from "./SharedSms.vue?vue&type=template&id=5ce94d8a&scoped=true"
import script from "./SharedSms.vue?vue&type=script&lang=js"
export * from "./SharedSms.vue?vue&type=script&lang=js"
import style0 from "./SharedSms.vue?vue&type=style&index=0&id=5ce94d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce94d8a",
  null
  
)

export default component.exports